export * from './tab-bar.component';
export * from './tab-bar-room.service';
